import request from "../../utils/request";

const API_ROUTE = `${process.env.REACT_APP_BASE_API}api/v1`;

export async function ssoTokenApi(code) {
  return request(`${API_ROUTE}/sso?code=${code}`, {
    method: "GET",
  });
}
export async function addGuestBySponsorApi(body) {
  return request(`${API_ROUTE}/users`, {
    method: "POST",
    data: body,
  });
}
export async function addEventApi(body) {
  return request(`${API_ROUTE}/users/event`, {
    method: "POST",
    data: body,
  });
}
